module.exports = __webpack_public_path__ + "static/media/coding_pic.1ba56b8e.jpg";